const ConfigGeneral={
    "inicio":{
        "categoria_productos":{
            "capa":"familia"
        }
    }
}

export default ConfigGeneral;
